module.exports = __webpack_public_path__ + "static/img/11.7121b52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/11.png
// module id = 7twF
// module chunks = 0